import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";
import { DatosReferenciaTarifaPP } from 'app/models/requireme';

const controller = rpcController("TarifaPP");
const crud = rpcCrudService<models.TarifaPP, models.TarifaPPDto>(controller);

const otros = cacheResource({
    add: crud.add,
    query: crud.query,
    delete: crud.delete,
    update: crud.update,
    get: crud.get,
    getMemo: crud.getMemo,

    ObtenerImportes: async (idTarifa: number, tipoServicio: models.TipoServicio, tipoPersona: models.TipoPersona, datosRef: DatosReferenciaTarifaPP) : Promise<models.ImportesTotalesTarifa>=>
        controller("ObtenerImportesTarifa", { idTarifa, tipoServicio, tipoPersona }, datosRef),

}, {
        query: true,
        get: true
    }, {
        ObtenerImportes: true
    });


export const TarifaPP = bindResource({ ...otros }); 


// WEBPACK FOOTER //
// ./app/resources/items/tarifapp.ts